export interface Bonus {
  number: number
  title: string
  short: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'Yoga Business Starter Guide™',
    short:
      'Set up your teaching offer, rates and schedule with a clearer professional foundation.',
  },
  {
    number: 2,
    title: 'Yoga Cueing & Transition Scriptbook™',
    short: 'Ready-to-use cueing language for clearer instructions and smoother transitions.',
  },
  {
    number: 3,
    title: 'Yoga Student Retention Playbook™',
    short: 'Build class experiences students want to return to, week after week.',
  },
  {
    number: 4,
    title: 'Yoga Business & Social Media Playbook™',
    short: 'Present your teaching online with more clarity, consistency and professionalism.',
  },
  {
    number: 5,
    title: 'Yoga Studio & Collaboration Guide™',
    short: 'Approach studios, propose collaborations and open new teaching opportunities.',
  },
]
